import { Combobox } from "@/components/ui/Combobox";
import { Country, type ICountry } from "country-state-city";

interface Props {
  placeholder?: string;
  onValueChange: ({ value, label }: { value: string; label: string }) => void;
  value?: string;
}

const countries = Country.getAllCountries().map((country: ICountry) => ({
  value: country.isoCode,
  label: country.name,
}));

export const CountryCombobox = (props: Props): JSX.Element => {
  return (
    <Combobox
      items={countries}
      value={props.value}
      onValueChange={(value) => {
        props.onValueChange({ label: value.label, value: value.value });
      }}
    />
  );
};
